<template>
    <div>
        <terms-form
            class="mb-5"
            :corporation="customerCorporation"
            :type="type"
            :terms="terms"
            :isEmbed="true"
            @load="load"
            @terms-accepted="saveCart"
        >
            <template #button>
                {{ $filters.capitalize($l10n.__('valider mon abonnement')) }}
            </template>
        </terms-form>
    </div>
</template>
<script>
import SAMMixins from '../../../mixins/subscription/SAMMixins';
import TermsForm from 'vcomponents/sellsyaccountmanager/TermsForm.vue';

// NEW
import WidgetMixins from '../../../mixins/sellsyaccountmanager/widgetMixins';

export default {

    components: {
        TermsForm,
    },
    mixins: [SAMMixins, WidgetMixins],
    props: {
        type: {
            type: String,
            required: true,
            default: 'saas',
            validator: (value) => {
                return ['saas', 'affil'].indexOf(value) !== -1;
            },
        },
        actualTerms: {
            type: Object | Boolean,
            default: false,
        },
    },
    data() {
        return {
            terms: {},
            terms_checked: false,
        };
    },
    created() {
        new Promise((resolve, reject) =>
            resolve(this.actualTerms || this.getTermsStatus(this.customerCorporation, this.type)),
        ).then((terms) => {
            if (this.isCartContext('upsale') && terms.status === 'accepted') return this.saveCart();
            this.terms = {
                status: 'pending',
                url: terms.url,
                version: terms.version,
            };
            this.$emit('load', false);
        });
    },
    methods: {
        load(load) {
            this.$emit('load', load);
        },
        saveCart() {
            return window.EventBus.emit('savecart');
        },
    },
};
</script>
